import React from 'react';

class Alerts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alerts: []
        }
    }

    removeAlert(alert) {
        this.setState({
            alerts: this.state.alerts.filter((o) => o !== alert)
        });
    }

    addAlert(alert) {
        this.setState(prevState => ({
            alerts: [...prevState.alerts, alert]
        }));
    }

    clearAlerts() {
        this.setState((prevState) => ({
            alerts: prevState.alerts.filter((alert) => alert.status !== 'success')
        }));
    }

    componentDidMount(){
        this.props.eventHandler.onAdd(this.addAlert.bind(this));
        this.props.eventHandler.onRemove(this.removeAlert.bind(this));
        this.props.eventHandler.onClear(this.clearAlerts.bind(this));
    }

    render() {
        return (
            <div className={'col-xs-8 col-xs-offset-2 text-center'} style={{paddingBottom: '3%'}} >
                {
                    this.state.alerts.map((alert, i) => {
                        return (
                            <div key={i} className={'alert alert-' + alert.status} >
                                <a href="#" className="close" onClick={() => this.removeAlert(alert) }>&times;</a>
                                {alert.message}
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export default Alerts;